export * from './additionalDocsExternal.service';
import { AdditionalDocsExternalService } from './additionalDocsExternal.service';
export * from './announcementCase.service';
import { AnnouncementCaseService } from './announcementCase.service';
export * from './announcementCaseExternal.service';
import { AnnouncementCaseExternalService } from './announcementCaseExternal.service';
export * from './authoritySetting.service';
import { AuthoritySettingService } from './authoritySetting.service';
export * from './authoritySettingExternal.service';
import { AuthoritySettingExternalService } from './authoritySettingExternal.service';
export * from './businessApiTraceLog.service';
import { BusinessApiTraceLogService } from './businessApiTraceLog.service';
export * from './businessGroupSetting.service';
import { BusinessGroupSettingService } from './businessGroupSetting.service';
export * from './businessMessageTraceLog.service';
import { BusinessMessageTraceLogService } from './businessMessageTraceLog.service';
export * from './codeTable.service';
import { CodeTableService } from './codeTable.service';
export * from './coreExternal.service';
import { CoreExternalService } from './coreExternal.service';
export * from './counselorSetting.service';
import { CounselorSettingService } from './counselorSetting.service';
export * from './custAuditPermSettingExternal.service';
import { CustAuditPermSettingExternalService } from './custAuditPermSettingExternal.service';
export * from './custAuditPermitSetting.service';
import { CustAuditPermitSettingService } from './custAuditPermitSetting.service';
export * from './custReviewExplainExternal.service';
import { CustReviewExplainExternalService } from './custReviewExplainExternal.service';
export * from './custReviewPermission.service';
import { CustReviewPermissionService } from './custReviewPermission.service';
export * from './custReviewPermissionExternal.service';
import { CustReviewPermissionExternalService } from './custReviewPermissionExternal.service';
export * from './customerServiceGroupSetting.service';
import { CustomerServiceGroupSettingService } from './customerServiceGroupSetting.service';
export * from './customerServiceGroupSettingExternal.service';
import { CustomerServiceGroupSettingExternalService } from './customerServiceGroupSettingExternal.service';
export * from './customerServiceMappingSetting.service';
import { CustomerServiceMappingSettingService } from './customerServiceMappingSetting.service';
export * from './customerServiceMappingSettingExternal.service';
import { CustomerServiceMappingSettingExternalService } from './customerServiceMappingSettingExternal.service';
export * from './masking.service';
import { MaskingService } from './masking.service';
export * from './messageResend.service';
import { MessageResendService } from './messageResend.service';
export * from './notificationLogExternal.service';
import { NotificationLogExternalService } from './notificationLogExternal.service';
export * from './personalDataColumn.service';
import { PersonalDataColumnService } from './personalDataColumn.service';
export * from './personalDataSearchLog.service';
import { PersonalDataSearchLogService } from './personalDataSearchLog.service';
export * from './reviewPermissionDealer.service';
import { ReviewPermissionDealerService } from './reviewPermissionDealer.service';
export * from './reviewPermissionDealerExternal.service';
import { ReviewPermissionDealerExternalService } from './reviewPermissionDealerExternal.service';
export * from './ruleEngine.service';
import { RuleEngineService } from './ruleEngine.service';
export * from './schedule.service';
import { ScheduleService } from './schedule.service';
export * from './scheduleExternal.service';
import { ScheduleExternalService } from './scheduleExternal.service';
export * from './scoringSetting.service';
import { ScoringSettingService } from './scoringSetting.service';
export * from './systemParameter.service';
import { SystemParameterService } from './systemParameter.service';
export * from './userBusinessRegionSetting.service';
import { UserBusinessRegionSettingService } from './userBusinessRegionSetting.service';
export const APIS = [AdditionalDocsExternalService, AnnouncementCaseService, AnnouncementCaseExternalService, AuthoritySettingService, AuthoritySettingExternalService, BusinessApiTraceLogService, BusinessGroupSettingService, BusinessMessageTraceLogService, CodeTableService, CoreExternalService, CounselorSettingService, CustAuditPermSettingExternalService, CustAuditPermitSettingService, CustReviewExplainExternalService, CustReviewPermissionService, CustReviewPermissionExternalService, CustomerServiceGroupSettingService, CustomerServiceGroupSettingExternalService, CustomerServiceMappingSettingService, CustomerServiceMappingSettingExternalService, MaskingService, MessageResendService, NotificationLogExternalService, PersonalDataColumnService, PersonalDataSearchLogService, ReviewPermissionDealerService, ReviewPermissionDealerExternalService, RuleEngineService, ScheduleService, ScheduleExternalService, ScoringSettingService, SystemParameterService, UserBusinessRegionSettingService];
